import { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  Card,
  Box,
  TableCell,
  TablePagination,
  TableFooter,
} from '@material-ui/core';
import { connect } from 'react-redux';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import Scrollbar from '../../../components/global/Scrollbar';
import TableCellHeader from '../../../components/global/TableCellHeader';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import PanelFilter from '../../../components/admin/PanelFilter';
import TableRowBody from '../../../components/global/TableRowBody';
import { onGet } from '../../../store/actions/global';
import RowFuvex from './ProspeccionFuvexRow';

const Prospeccion: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const [jfn, setJfn] = useState({
    data: [],
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [fuvex, setFuvex] = useState({
    data: [],
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({
    startDate: null,
    endDate: null,
  });
  const title = 'Prospección de Ventas';
  const headersJdn = [
    'Jefe de Negocio',
    'Vendedores con código - total',
    'Vendedores que han usado la herramienta (diario) acumulado',
    'Semaforo de vendedores activos',
    'Nº de consulta - acumulado',
    'Promedio consultas x vendedor por día',
    'Semáforo',
  ];
  const headersFuvex = [
    'Canales de Venta',
    'Vendedores con código - total',
    'Vendedores que han usado la herramienta (diario) acumulado',
    'Semaforo de vendedores activos',
    'Nº de consulta - acumulado',
    'Promedio consultas x vendedor por día',
    'Semáforo',
  ];

  const onSubmit = async (values) => {
    const { startDate, endDate } = values;
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/prospeccion',
        body: { startDate, endDate, limit: defaultLimit },
      });
      setJfn(response?.jfn);
      setFuvex(response?.fuvex);
    }
  };

  const handleChangePageJfn = async (event: unknown, page: number) => {
    const { startDate, endDate } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/prospeccion/detail',
      body: {
        startDate,
        endDate,
        limit: Number(jfn.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangePageFuvex = async (event: unknown, page: number) => {
    const { startDate, endDate } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/prospeccion/detail',
      body: {
        startDate,
        endDate,
        limit: Number(fuvex.pages.limit),
        page,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  const handleChangeRowsPerPageJfn = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { startDate, endDate } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/prospeccion/detail',
      body: {
        startDate,
        endDate,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPageFuvex = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { startDate, endDate } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/prospeccion/detail',
      body: {
        startDate,
        endDate,
        limit: Number(event.target.value),
        page: 0,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} />
        <Box mt={3}>
          <Card>
            <Scrollbar>
              <Table size="small" className="zoomin">
                <TableHead>
                  <TableRow>
                    {headersJdn.map((header) => (
                      <TableCellHeader key={header} align="center">
                        {header}
                      </TableCellHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {jfn.data.map((item) => (
                    <TableRowBody key={item.id}>
                      <TableCell align="center" width={400}>
                        {item.jfn}
                      </TableCell>
                      <TableCell align="center" width={250}>
                        {item.vendedoresTotal}
                      </TableCell>
                      <TableCell align="center">
                        {item.vendedoresDiario}
                      </TableCell>
                      <TableCell align="center">
                        {item.semaforoActivo}
                        %
                      </TableCell>
                      <TableCell align="center" width={200}>
                        {item.consultaAcumulado}
                      </TableCell>
                      <TableCell align="center" width={250}>
                        {item.promConsultaDiario}
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <img
                          src={`/static/images/${item.semaforo}.png`}
                          alt={item.semaforo}
                        />
                      </TableCell>
                    </TableRowBody>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      backIconButtonProps={{
                        title: 'Página anterior',
                      }}
                      nextIconButtonProps={{
                        title: 'Página siguiente',
                      }}
                      rowsPerPageOptions={[5, 10, 15, 20]}
                      labelRowsPerPage="Registros por página"
                      labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                      count={jfn.pages.total}
                      page={jfn.pages.current}
                      rowsPerPage={jfn.pages.limit}
                      onPageChange={handleChangePageJfn}
                      onRowsPerPageChange={handleChangeRowsPerPageJfn}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Scrollbar>
          </Card>
        </Box>
        <Box mt={3}>
          <Card>
            <Scrollbar>
              <Table size="small" className="zoomin">
                <TableHead>
                  <TableRow>
                    {headersFuvex.map((header) => (
                      <TableCellHeader key={header} align="center">
                        {header}
                      </TableCellHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fuvex.data.map((item) => (
                    <RowFuvex item={item} />
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      backIconButtonProps={{
                        title: 'Página anterior',
                      }}
                      nextIconButtonProps={{
                        title: 'Página siguiente',
                      }}
                      rowsPerPageOptions={[5, 10, 15, 20]}
                      labelRowsPerPage="Registros por página"
                      labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                      count={fuvex.pages.total}
                      page={fuvex.pages.current}
                      rowsPerPage={fuvex.pages.limit}
                      onPageChange={handleChangePageFuvex}
                      onRowsPerPageChange={handleChangeRowsPerPageFuvex}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Scrollbar>
          </Card>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(Prospeccion);
